import React from 'react';

import BaseNavigator from './BaseNavigator';

const MemberNavigator = () => {
  return <BaseNavigator signedIn={true} isPro={true} />;
};

export default React.memo(MemberNavigator);
